// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeResourcesEdu = {
  eduCourse: "course",
  eduLearningRecord: "learning record",
  eduMember: "EDU member",
  eduOrg: "EDU organization",
  eduOverviewLearnerMessage: "learner message",
  eduProject: "project training",
  eduPublicCourse: "public course",
  eduTeachingPlan: "teaching plan",
  eduAuth: "EDU authentication",
  eduOverview: "EDU overview",
} as const;
